export const DATA_CY_MAIN_LAYOUT = 'main-layout';